import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface CopyClipboardProps {
    className: string;
    copyText: string;
    onCopy: () => void;
    removeClipboard?: () => void;
}
const CopyClipboard: React.FC<CopyClipboardProps> = (
    props: CopyClipboardProps
) => {
    return (
        <p className={`${props.className}-text`}>
            {props.copyText}
            <CopyToClipboard text={props.copyText} onCopy={props.onCopy}>
                <span
                    className={`${props.className}-copy`}
                    title="Click to copy the link"
                >
                    COPY
                </span>
            </CopyToClipboard>
            {props.removeClipboard && (
                <div
                    className="modal__link-generator--close"
                    onClick={props.removeClipboard}
                >
                    <i className="nx nx-close" />
                </div>
            )}
        </p>
    );
};

export default CopyClipboard;
